import {IService, SystemComponentType} from '@gongxigames/framework/core/types';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {Device} from '@gongxigames/framework/core/services/Device';
import {inject, injectable} from '@gongxigames/framework/core/installer';

@injectable()
export class FullscreenManager implements IService {
    public static NAME: symbol = CoreDI.FullscreenManager;
    public type: SystemComponentType = 'service';

    private requestFullscreenListener: () => void = this.requestFullscreen.bind(this);
    private gestureStartListener: (e: Event) => void = this.onGestureStart.bind(this);

    @inject(CoreDI.Device)
    private _device!: Device;

    public init(): void {
        if (!this._device.iPad && this._device.isMobile) {
            if (!this._device.iOS) {
                this.addEventListenerRequestFullscreen();
            }

            document.addEventListener('gesturestart', this.gestureStartListener);
        }
    }

    public destroy(): void {
        this.removeListeners();
    }

    public requestFullscreen(): void {
        try {
            if (this._device.requestFullscreen && !this.isFullscreen() && (document.body as any)[this._device.requestFullscreen]) {
                (document.body as any)[this._device.requestFullscreen]();
            }
        } catch {

        }
    }

    public exitFullscreen(): void {
        try {
            if (this._device.cancelFullscreen && this.isFullscreen() && (document as any)[this._device.cancelFullscreen]) {
                (document as any)[this._device.cancelFullscreen]();
            }
        } catch {

        }
    }

    public isFullscreen(): boolean {
        return !!(document as any)[this._device.fullscreenElement];
    }

    public removeListeners(): void {
        document.removeEventListener('gesturestart', this.gestureStartListener);

        this.removeEventListenerRequestFullscreen();
    }

    protected addEventListenerRequestFullscreen(): void {
        if (this._device.fullscreen) {
            document.body.addEventListener('touchend', this.requestFullscreenListener);
        }
    }

    protected removeEventListenerRequestFullscreen(): void {
        if (this._device.fullscreen) {
            document.body.removeEventListener('touchend', this.requestFullscreenListener);
        }
    }

    private onGestureStart(e: Event): void {
        e.preventDefault();
    }
}
